import { useEffect, useState } from 'react';
export const XLARGE = 'xlarge';
export const LARGE = 'large';
export const MEDIUM = 'medium';
export const SMALL = 'small';

const useCompareMediaQuery = () => {
  const [breakpoint, setActiveBreakpoint] = useState(null);
  const queries = {
    [SMALL]: 'only screen and (min-width: 0px)',
    [MEDIUM]: 'only screen and (min-width: 600px)',
    [LARGE]: 'only screen and (min-width: 960px)',
    [XLARGE]: 'only screen and (min-width: 1500px)',
  };

  useEffect(() => {
    let windowMediaList = {};

    const onChange = (e) => {
      if (e.matches) {
        setActiveBreakpoint(
          Object.keys(queries).find((key) => queries[key] === e.media)
        );
      } else {
        if (window.matchMedia(queries[XLARGE]).matches) {
          setActiveBreakpoint(XLARGE);
          return;
        }
        if (window.matchMedia(queries[LARGE]).matches) {
          setActiveBreakpoint(LARGE);
          return;
        }
        if (window.matchMedia(queries[MEDIUM]).matches) {
          setActiveBreakpoint(MEDIUM);
          return;
        }
        setActiveBreakpoint(SMALL);
      }
    };

    let currentMedia = null;

    for (let key of Object.keys(queries)) {
      let media = window.matchMedia(queries[key]);
      media.addEventListener('change', onChange);
      if (media.matches) {
        currentMedia = key;
      }
      windowMediaList[key] = media;
    }

    setActiveBreakpoint(currentMedia);

    return () => {
      for (let key of Object.keys(windowMediaList)) {
        windowMediaList[key].removeEventListener('change', onChange);
      }
    };
  }, []);

  return breakpoint;
};

export default useCompareMediaQuery;
